import { createPortal } from "react-dom";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function CancelFollowUpModal({ isOpen, onClose, onConfirm }) {
  const { t } = useTranslation();
  const [reason, setReason] = useState("");

  useEffect(() => {
    if (!isOpen) setReason("");
  }, [isOpen]);

  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999] text-primary">
      <div className="bg-white p-6 rounded shadow w-full max-w-md">
        <h3 className="font-bold text-lg mb-4">
          {t("followUps.cancelFollowUpTitle")}
        </h3>

        <textarea
          className="textarea textarea-bordered w-full h-24"
          placeholder={t("followUps.cancelReasonPlaceholder")}
          value={reason}
          onChange={(e) => {
            setReason(e.target.value);
          }}
        />

        <div className="flex justify-end space-x-2 mt-4">
          <button
            className="rounded-full border border-primary px-4 py-2"
            onClick={onClose}
          >
            {t("global.cancel")}
          </button>
          <button
            className="rounded-full border bg-red-500 text-white px-4 py-2"
            onClick={() => {
              if (!reason || reason.trim().length === 0) {
                alert(t("followUps.enterCancelReason"));
                return;
              }
              onConfirm(reason);
              setReason("");
            }}
          >
            {t("followUps.confirmCancel")}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
